import { render } from "./Todo.vue?vue&type=template&id=612af620"
import script from "./Todo.vue?vue&type=script&lang=js"
export * from "./Todo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gill\\OneDrive - csnt.com.tw\\桌面\\前端課程作業\\todolist\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__